import {Table} from "reactstrap";
import {useUser} from "../../contexts/AuthContext";
import ActivityItem from "./ActivityItem";

const findMaxFps = (activities: any[]) => {
  if (!activities || activities.length === 0) {
    return 0; // Return 0 or a suitable default if there are no activities
  }

  return activities.reduce((max, activity) => {
    // Ensure that activity.MaxFps is a number and not undefined
    if (typeof activity.MaxFps === "number") {
      return Math.max(max, activity.MaxFps);
    }
    return max;
  }, 0); // Start with 0 as the initial maximum
};

const ActivitiesCollection = (props: any) => {
  const {user} = useUser();

  const timezoneOffsetMinutes: number = user.settings.timezoneOffsetMinutes;
  const color = props.color;

  if (props === undefined || !props.items) {
    return (
      <>
        <h4>No files found</h4>
      </>
    );
  }

  const scaleFactor: number = findMaxFps(props.activities);

  let items: any[] = [];

  let counter: number = 1;
  for (const item of props.items) {
    items.push(
      <ActivityItem
        {...item}
        index={counter}
        scaleFactor={scaleFactor}
        key={`i-${counter}`}
        rank={counter}
        timezoneOffsetMinutes={timezoneOffsetMinutes}
        color={color}
        {...props}
      />
    );
    counter += 1;
  }

  return (
    <>
      <Table>
        <thead>
          <tr className="user-activity-row-heading">
            <th style={{width: "4%"}} className="text-center">
              <h5 className="user-activity-heading">View</h5>
            </th>
            <th style={{width: "10%"}}>
              <h5 className="user-activity-heading">Date</h5>
            </th>
            <th style={{width: "12%"}}>
              <h5 className="user-activity-heading">World</h5>
            </th>
            <th style={{width: "10%"}}>
              <h5 className="user-activity-heading">Duration</h5>
            </th>
            <th style={{width: "32%"}}>
              <h5 className="user-activity-heading">Spec</h5>
            </th>
            <th style={{width: "8%"}}>
              <h5 className="user-activity-heading-right">Client</h5>
            </th>
            <th style={{width: "6%"}}>
              <h5 className="user-activity-heading-right">Crowding</h5>
            </th>
            <th style={{width: "6%"}}>
              <h5 className="user-activity-heading-right">Max FPS</h5>
            </th>
            <th style={{width: "6%"}}>
              <h5 className="user-activity-heading-right">Avg FPS</h5>
            </th>
            <th style={{width: "6%"}}>
              <h5 className="user-activity-heading-right">
                P<sub>1</sub> FPS
              </h5>
            </th>
          </tr>
        </thead>
        <tbody>{items}</tbody>
      </Table>
    </>
  );
};

export default ActivitiesCollection;
